import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.preview.down.block': '下載此頁面到本地項目',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  'attendance.new': '新增',
  'attendance.edit': '編輯',
  'attendance.delete': '刪除',
  'attendance.title': '考勤記錄',
  'attendance.ID': 'ID',
  'attendance.staffId': '員工ID',
  'attendance.staff': '員工',
  'attendance.pleaseSelectAttendanceType': '請選擇考勤類型',
  'attendance.attendanceTypePlaceholder': '選擇考勤類型',
  'attendance.timestamp': '時間戳',
  'attendance.torranceMinutes': '容忍分鐘',
  'attendance.expectedTime': '預期時間',
  'attendance.site': '物業',
  'attendance.shift': '班次',
  'attendance.checkpoint': '檢查點',
  'attendance.requireOB': '需要OB編號',
  'attendance.createdAt': '建立時間',
  'attendance.updatedAt': '更新時間',
  'attendance.actions': '操作',
  'attendance.createAttendance': '新增考勤',
  'attendance.editAttendance': '編輯考勤',
  'attendance.cancel': '取消',
  'attendance.create': '建立',
  'attendance.update': '更新',
  'attendance.deleted': '考勤已刪除',
  'attendance.deleteFailed': '刪除考勤失敗',
  'attendance.created': '考勤已建立',
  'attendance.updated': '考勤已更新',
  'attendance.saveFailed': '儲存考勤失敗',
  'attendance.deleteConfirm': '確定要刪除此考勤嗎？',
  'attendance.yes': '是',
  'attendance.no': '否',
  'attendance.pleaseSelectStaff': '請選擇員工',
  'attendance.pleaseSelectSite': '請選擇物業',
  'attendance.pleaseSelectShift': '請選擇班次',
  'attendance.pleaseSelectCheckpoint': '請選擇檢查點',
  'attendance.pleaseInputShiftAssignmentId': '請輸入班次分配ID',
  'attendance.pleaseSelectTimestamp': '請選擇時間',
  'attendance.latitude': '緯度',
  'attendance.longitude': '經度',
  'attendance.ip': 'IP位址',
  'attendance.latitudeNumber': '緯度必須為數字',
  'attendance.longitudeNumber': '經度必須為數字',
  'attendance.latitudePlaceholder': '緯度（可選）',
  'attendance.longitudePlaceholder': '經度（可選）',
  'attendance.ipPlaceholder': 'IP位址（可選）',
  'attendance.shiftAssignmentId': '班次分配ID',
  'attendance.attendanceType': '考勤類型',
  'attendance.clockIn': '簽到',
  'attendance.clockOut': '簽退',
  'attendance.obNumber': 'OB編號',
  'attendance.patrol': '巡邏',
  'attendance.approvalStatus': '審批狀態',
  'attendance.approved': '已批准',
  'attendance.rejected': '已拒絕',
  'attendance.pending': '待處理',
  'attendance.approvedBy': '批准人',
  'userManagement.showing': '顯示',
  'userManagement.of': '共',
  'userManagement.items': '條',

  'attendance.remark': '備註',
  'attendance.approve': '批准',
  'attendance.reject': '拒絕',
  'attendance.approvalTitle': '批准/拒絕出勤記錄',
  'attendance.approvalDecision': '審批決定',
  'attendance.pleaseSelectApprovalDecision': '請選擇審批決定',
  'attendance.remarkPlaceholder': '審批決定的可選備註',
  'attendance.submit': '提交',
  'attendance.approvalSuccess': '出勤記錄審批狀態更新成功',
  'attendance.approvalFailed': '更新出勤記錄審批狀態失敗',
  'checkpoint.create': '新增檢查點',
  'checkpoint.edit': '編輯檢查點',
  'checkpoint.name': '名稱',
  'checkpoint.description': '描述',
  'checkpoint.referenceCode': '參考代碼',
  'checkpoint.active': '啟用',
  'checkpoint.cancel': '取消',
  'checkpoint.pleaseInputName': '請輸入檢查點名稱',
  'checkpoint.pleaseInputReferenceCode': '請輸入參考代碼',
  'checkpoint.update': '更新',
  'incident.type.incident': '事件',
  'incident.type.maintenance': '維護',
  'incident.type.general': '一般',
  'incident.type.complain': '投訴',
  'attendance.showing': '顯示',

  // Transaction translations
  'transaction.title': '出入帳記錄',
  'transaction.create': '建立出入帳',
  'transaction.edit': '編輯出入帳',
  'transaction.description': '描述',
  'transaction.amount': '金額',
  'transaction.currency': '貨幣',
  'transaction.category': '類別',
  'transaction.unit': '單位',
  'transaction.status': '狀態',
  'transaction.transactionDate': '出入帳日期',
  'transaction.attachment': '附件',
  'transaction.createdAt': '建立時間',
  'transaction.actions': '操作',
  'transaction.referenceType': '參考類型',
  'transaction.referenceId': '參考ID',
  'transaction.protected': '受保護',
  'transaction.uploadImage': '上傳圖片',
  'transaction.selectCategory': '選擇類別',
  'transaction.selectUnit': '選擇單位',
  'transaction.descriptionRequired': '請輸入描述',
  'transaction.amountRequired': '請輸入金額',
  'transaction.createSuccess': '出入帳建立成功',
  'transaction.updateSuccess': '出入帳更新成功',
  'transaction.operationFailed': '出入帳操作失敗',
  'transaction.createTitle': '建立出入帳',
  'transaction.editTitle': '編輯出入帳',
  'transaction.income': '收入',
  'transaction.expense': '支出',
  'transaction.status.pending': '待處理',
  'transaction.status.approved': '已批准',
  'transaction.status.rejected': '已拒絕',
  'transaction.status.cancelled': '已取消',
  'transaction.categoryRequired': '請選擇類別',
  'transaction.deleteSuccess': '出入帳刪除成功！',
  'transaction.deleteFailed': '刪除出入帳失敗',
  'transaction.deleteConfirm': '確定要刪除此出入帳嗎？',
  'transaction.yes': '是',
  'transaction.no': '否',

  'attendance.of': '共',
  'attendance.items': '條',
  'incident.status.open': '開啟',
  'incident.status.assigned': '已分配',
  'incident.status.inProgress': '進行中',
  'incident.status.reviewing': '審核中',
  'incident.status.resolved': '已解決',
  'incident.status.closed': '已關閉',
  'incident.severity.low': '低',
  'incident.severity.medium': '中',
  'incident.severity.high': '高',
  'incident.severity.critical': '嚴重',
  'incident.create.success': '事件建立成功',
  'incident.create.failed': '事件建立失敗',
  'incident.management': '事件管理',
  'incident.kanban': '看板',
  'incident.calendar': '日曆',
  'incident.addIncident': '新增事件',
  'incident.selectSite': '選擇物業',
  'incident.type': '類型',
  'incident.status': '狀態',
  'incident.severity': '嚴重程度',
  'incident.selectSitePrompt': '請選擇物業以在看板或日曆檢視中查看日誌。',
  'incident.addNewIncident': '新增事件',
  'incident.create': '建立',
  'incident.logType': '日誌類型',
  'incident.pleaseSelectLogType': '請選擇日誌類型',
  'incident.selectLogType': '選擇日誌類型',
  'incident.title': '標題',
  'incident.pleaseEnterTitle': '請輸入標題',
  'incident.enterTitle': '輸入標題',
  'incident.description': '描述',
  'incident.pleaseEnterDescription': '請輸入描述',
  'incident.enterDescription': '輸入描述',
  'incident.pleaseSelectSeverity': '請選擇嚴重程度',
  'incident.selectSeverity': '選擇嚴重程度',
  'incident.attachments': '附件（選填）',
  'incident.selectFiles': '選擇檔案',
  'incident.updateStatus': '更新狀態',
  'incident.newState': '新狀態',
  'incident.pleaseSelectNewState': '請選擇新狀態',
  'incident.assignTo': '分配給',
  'incident.pleaseSelectStaffToAssign': '請選擇要分配的員工',
  'incident.notes': '備註',
  'incident.pleaseEnterNotes': '請輸入備註',
  'incident.logDetails': '日誌詳情',
  'incident.currentState': '目前狀態',
  'incident.loggedBy': '記錄人',
  'incident.createdAt': '建立時間',
  'incident.stateChanges': '狀態變更',
  'incident.changedStateFromTo': '狀態從{from}變為{to}',
  'incident.assignedTo': '分配給：{name}',
  'incident.responses': '回覆',
  'incident.edit': '編輯',
  'incident.pleaseEnterResponse': '請輸入回覆內容',
  'incident.addResponsePlaceholder': '新增回覆...',
  'incident.updateResponse': '更新回覆',
  'incident.addResponse': '新增回覆',
  'incident.cancel': '取消',
  'shiftAssignment.siteShift': '物業 - 班次',
  'shiftAssignment.assigned': '已分配',
  'shiftAssignment.noSites': '找不到物業',
  'shiftAssignment.selectRegionDistrict': '請選擇區域和地區',
  'shiftAssignment.filterByRegion': '篩選區域',
  'shiftAssignment.filterByDistrict': '篩選地區',
  'shiftAssignment.monthPicker': '選擇月份',
  'shiftAssignment.importExcel': '匯入Excel',
  'shiftAssignment.import': '匯入',
  'shiftAssignment.selectFile': '選擇Excel檔案',
  'shiftAssignment.fileRequirements': '支援 .xlsx 和 .xls 檔案，最大 10MB',
  'shiftAssignment.importSuccess': '匯入成功完成',
  'shiftAssignment.importWithConflicts': '匯入完成但有衝突',
  'shiftAssignment.importError': '匯入失敗',
  'shiftAssignment.invalidFileType': '只能上傳Excel檔案！',
  'shiftAssignment.fileTooLarge': '檔案必須小於10MB！',
  'shiftAssignment.noFileSelected': '請選擇要匯入的檔案',
  'shiftAssignment.importResult': '匯入結果',
  'shiftAssignment.totalAssignments': '總分配數',
  'shiftAssignment.createdAssignments': '已建立分配',
  'shiftAssignment.skippedAssignments': '已跳過分配',
  'shiftAssignment.conflicts': '衝突',
  'shiftAssignment.conflictDetails': '衝突詳情',
  'shiftAssignment.legend': '圖例',
  'shiftAssignment.sunday': '週日',
  'shiftAssignment.holiday': '假期',
  'shiftAssignment.holidayName': '假期名稱',
  'shiftAssignment.originalName': '原名',
  // Region translations
  'region.hongKong': '香港島',
  'region.kowloon': '九龍',
  'region.newTerritories': '新界',
  // District translations
  'district.centralAndWestern': '中西區',
  'district.wanChai': '灣仔',
  'district.eastern': '東區',
  'district.southern': '南區',
  'district.yauTsimMong': '油尖旺',
  'district.shamShuiPo': '深水埗',
  'district.kowloonCity': '九龍城',
  'district.wongTaiSin': '黃大仙',
  'district.kwunTong': '觀塘',
  'district.tuenMun': '屯門',
  'district.yuenLong': '元朗',
  'district.north': '北區',
  'district.taiPo': '大埔',
  'district.saiKung': '西貢',
  'district.shaTin': '沙田',
  'district.kwaiTsing': '葵青',
  'district.tsuenWan': '荃灣',
  'district.islands': '離島',
  'shiftDetail.staff': '員工',
  'shiftDetail.notMapped': '未對應',
  'shiftDetail.employeeId': '員工編號',
  'shiftDetail.title': '職稱',
  'shiftDetail.phone': '電話',
  'shiftDetail.overnight': '夜班',
  'shiftDetail.dayShift': '日班',
  'shiftDetail.manageStaff': '管理員工',
  'shiftDetail.noStaffMapped': '沒有員工對應到此班次',
  'shiftDetail.assignToThisShift': '分配到此班次',
  'shiftDetail.assignToOtherShift': '分配到其他班次',
  'shiftDetail.markAsLeave': '標記為請假',
  'shiftDetail.removeAssignment': '移除分配',
  'shiftDetail.removeAssignmentConfirm': '確定要移除此分配嗎？',
  'shiftDetail.cancelLeave': '取消請假',
  'shiftDetail.cancelLeaveConfirm': '確定要取消此請假吗？',
  'shiftDetail.yes': '是',
  'shiftDetail.no': '否',
  'shiftDetail.assignShift': '分配班次',
  'shiftDetail.assignToOtherShiftTitle': '分配到其他班次',
  'shiftDetail.confirmShiftAssignment': '確認分配班次？',
  'shiftDetail.addLeave': '新增請假',
  'shiftDetail.annualLeave': '年假',
  'shiftDetail.sickLeave': '病假',
  'shiftDetail.personalLeave': '事假',
  'shiftDetail.leaveReason': '請假原因',
  'shiftDetail.leaveAdded': '請假新增成功',
  'shiftDetail.leaveAddFailed': '新增請假失敗',
  'shiftDetail.assignmentCreated': '分配建立成功',
  'shiftDetail.assignmentCreateFailed': '建立分配失敗',
  'shiftDetail.assignmentDeleted': '分配刪除成功',
  'shiftDetail.assignmentDeleteFailed': '刪除分配失敗',
  'shiftDetail.leaveCancelled': '請假已取消',
  'shiftDetail.leaveCancelFailed': '取消請假失敗',
  'shiftDetail.currentStaff': '目前員工',
  'shiftDetail.name': '姓名',
  'shiftDetail.action': '操作',
  'shiftDetail.remove': '移除',
  'shiftDetail.addStaff': '新增員工',
  'shiftDetail.selectStaffToAdd': '選擇要新增的員工',
  'shiftDetail.fetchStaffFailed': '取得可用員工失敗',
  'shiftDetail.staffMapped': '員工對應成功',
  'shiftDetail.staffMapFailed': '員工對應失敗',
  'shiftDetail.staffRemoved': '員工移除成功',
  'shiftDetail.staffRemoveFailed': '員工移除失敗',
  'shiftDetail.fillAllFields': '請填寫所有必填項',
  'shiftDetail.selectSiteAndShift': '選擇物業和班次：',
  'shiftDetail.selectSite': '選擇物業',
  'shiftDetail.selectShift': '選擇班次',
  'menu.admin.asset-management': '資產管理',
  'siteDetail.title': '物業詳情',
  'siteDetail.siteInformationTitle': '物業資訊',
  'siteDetail.name': '名稱',
  'siteDetail.shortName': '簡稱',
  'siteDetail.address': '地址',
  'siteDetail.district': '地區',
  'siteDetail.region': '區域',
  // duplicate key removed: 'siteDetail.status'
  'siteDetail.active': '啟用',
  'siteDetail.inactive': '停用',
  'siteDetail.basicInformation': '基本資訊',
  'siteDetail.siteID': '物業ID',
  'siteDetail.unitsTitle': '單元',
  'siteDetail.addUnit': '新增單元',
  'siteDetail.editUnit': '編輯單元',
  'siteDetail.deleteUnit': '刪除單元',
  'siteDetail.unitNumber': '單元編號',
  'siteDetail.occupied': '已佔用',
  'siteDetail.vacant': '空置',
  'siteDetail.occupiedLabel': '已佔用',
  'siteDetail.vacantLabel': '空置',
  'siteDetail.action': '操作',
  'siteDetail.edit': '編輯',
  'siteDetail.delete': '刪除',
  'siteDetail.addShift': '新增班次',
  'siteDetail.shiftsTitle': '班次',
  'siteDetail.shiftName': '班次名稱',
  'siteDetail.time': '時間',
  'siteDetail.overnight': '通宵',
  'siteDetail.overnightShift': '通宵班次',
  'siteDetail.requiredHeadcount': '所需人數',
  'siteDetail.headcount': '人數',
  'siteDetail.assignedStaff': '已分配員工',
  'siteDetail.manageStaff': '管理員工',
  'siteDetail.manageShifts': '管理班次',
  'siteDetail.shiftUpdatedSuccess': '班次更新成功',
  'siteDetail.shiftCreatedSuccess': '班次建立成功',
  'siteDetail.operationFailed': '操作失敗',
  'siteDetail.checkpointManagementTitle': '巡查點管理',
  'siteDetail.addCheckpoint': '新增巡查點',
  'siteDetail.referenceCode': '參考代碼',
  'siteDetail.requireObNumber': '需要OB編號',
  'siteDetail.description': '描述',
  'siteDetail.activeLabel': '啟用',
  'siteDetail.inactiveLabel': '停用',
  'siteDetail.checkpointCreated': '巡查點建立成功',
  'siteDetail.checkpointUpdated': '巡查點更新成功',
  'siteDetail.checkpointSaveFailed': '儲存巡查點失敗',
  'siteDetail.contactNumbersTitle': '聯絡電話',
  'siteDetail.addPhone': '新增電話',
  'siteDetail.phoneNumber': '電話號碼',
  'siteDetail.phoneAddedSuccess': '電話新增成功',
  'siteDetail.phoneUpdatedSuccess': '電話更新成功',
  'siteDetail.phoneDeletedSuccess': '電話刪除成功',
  'siteDetail.fetchSiteDetailsError': '獲取物業詳情失敗',
  'siteDetail.fetchUnitsError': '獲取單元失敗',
  'siteDetail.fetchLogsError': '獲取日誌失敗',
  'siteDetail.logCreatedSuccess': '日誌建立成功',
  'siteDetail.logUpdatedSuccess': '日誌更新成功',
  'siteDetail.logResolveFailed': '日誌結案失敗',
  'siteDetail.logResolvedSuccess': '日誌結案成功',
  'siteDetail.unitCreatedSuccess': '單元建立成功',
  'siteDetail.unitUpdatedSuccess': '單元更新成功',
  'siteDetail.unitDeletedSuccess': '單元刪除成功',
  'siteDetail.unitSaveFailed': '儲存單元失敗',
  'siteDetail.unitDeleteFailed': '刪除單元失敗',
  'siteDetail.addLog': '新增日誌',
  'siteDetail.recentLogsTitle': '最新日誌',
  'siteDetail.logType': '日誌類型',
  'siteDetail.incident': '事件',
  'siteDetail.maintenance': '維護',
  'siteDetail.general': '一般',
  'siteDetail.severity': '嚴重程度',
  'siteDetail.low': '低',
  'siteDetail.medium': '中',
  'siteDetail.high': '高',
  'siteDetail.critical': '嚴重',
  'siteDetail.status': '狀態',
  'siteDetail.open': '未處理',
  'siteDetail.inProgress': '處理中',
  'siteDetail.resolved': '已解決',
  'siteDetail.closed': '已關閉',
  'siteDetail.createdBy': '建立人',
  'siteDetail.createdAt': '建立時間',
  'siteDetail.resolution': '解決方案',
  'siteDetail.resolvedBy': '解決人',
  'siteDetail.resolvedAt': '解決時間',
  'siteDetail.viewDetails': '查看詳情',
  'siteDetail.updateStatus': '更新狀態',
  'siteDetail.logDetailsTitle': '日誌詳情 - {title}',
  'siteDetail.currentState': '當前狀態',
  'siteDetail.loggedBy': '記錄人',
  'siteDetail.stateChanges': '狀態變更',
  'siteDetail.changedStateFrom': '狀態從',
  'siteDetail.to': '變為',
  'siteDetail.assignedTo': '分配給',
  'siteDetail.responses': '回覆',
  // duplicate keys removed below; keep the earlier definitions above
  'siteDetail.pleaseEnterResponse': '請輸入回覆內容',
  'siteDetail.responseAddedSuccess': '回覆新增成功',
  'siteDetail.responseAddFailed': '新增回覆失敗',
  'siteDetail.responseUpdatedSuccess': '回覆更新成功',
  'siteDetail.responseUpdateFailed': '回覆更新失敗',
  'siteDetail.manageShiftPreferencesTitle': '管理班次偏好 - {employee_id}',
  'siteDetail.preferredShifts': '偏好班次',
  'siteDetail.selectShifts': '請選擇班次',
  'siteDetail.currentPreferences': '當前偏好',
  'siteDetail.remove': '移除',
  'siteDetail.preferencesUpdatedSuccess': '偏好更新成功',
  'siteDetail.preferencesUpdateFailed': '偏好更新失敗',
  'siteDetail.preferenceRemovedSuccess': '偏好移除成功',
  'siteDetail.preferenceRemoveFailed': '偏好移除失敗',
  'siteDetail.fetchPreferencesError': '獲取偏好失敗',
  'siteDetail.manageStaffTitle': '管理員工 - {name}',
  'siteDetail.assignStaff': '分配員工',
  'siteDetail.assignStaffTitle': '分配員工',
  'siteDetail.selectStaff': '選擇員工',
  'siteDetail.selectStaffToAssign': '請選擇要分配的員工',
  'siteDetail.assignStaffWarning': '部分員工無法分配: {staff_ids}',
  'siteDetail.assignStaffSuccess': '成功分配 {mapped_staff_count} 名員工',
  'siteDetail.assignStaffError': '分配員工失敗',
  'siteDetail.fetchStaffListError': '獲取員工列表失敗',
  'siteDetail.loading': '加載中...',
  'siteDetail.employeeID': '員工編號',
  'siteDetail.type': '類型',
  'siteDetail.complain': '投訴',
  'siteDetail.deletePhoneTitle': '刪除電話',
  'siteDetail.deletePhoneConfirm': '確定要刪除此電話號碼嗎？',
  // removed duplicate preference and assignStaff keys (already defined above)
  // duplicate of earlier key 'siteDetail.assignStaffError' removed
  'siteDetail.deleteUnitTitle': '刪除單元',
  'siteDetail.deleteUnitConfirm': '確定要刪除此單元嗎？',
  'siteDetail.patrolRouteCreated': '巡邏路線建立成功',
  'siteDetail.patrolRouteUpdated': '巡邏路線更新成功',
  'siteDetail.patrolRouteSaveFailed': '巡邏路線儲存失敗',
  'siteDetail.deletePatrolRouteTitle': '刪除巡邏路線',
  'siteDetail.deletePatrolRouteConfirm': '確定要刪除此巡邏路線嗎？',
  'siteDetail.patrolRouteDeleted': '巡邏路線刪除成功',
  'siteDetail.patrolRouteDeleteFailed': '巡邏路線刪除失敗',
  'siteDetail.fetchPatrolRouteCheckpointsError': '獲取巡邏路線檢查點失敗',
  'siteDetail.accessDenied': '無權限訪問',
  'siteDetail.editShiftTitle': '編輯班次',
  'siteDetail.editPhoneTitle': '編輯電話',
  'siteDetail.updateLogTitle': '更新日誌',
  'unitModal.editTitle': '編輯單元',
  'unitModal.addTitle': '新增單元',
  'unitModal.occupied': '已佔用',
  'unitModal.availableTenants': '可用租戶',
  'unitModal.assignedTenants': '已分配租戶',
  'unitModal.tenantName': '租戶名稱',
  'unitModal.phoneNumber': '電話號碼',
  'unitModal.leaseStart': '租賃開始',
  'unitModal.leaseEnd': '租賃結束',
  'unitModal.createTenant': '創建租戶',
  'unitModal.fetchUnitTenantsError': '獲取單元租戶失敗',
  'unitModal.fetchAllTenantsError': '獲取所有租戶失敗',
  'unitModal.createTenantSuccess': '租戶創建成功',
  'unitModal.createTenantError': '創建租戶失敗',
  'welcome.learnMore': '了解更多',
  'welcome.shiftAttendanceToday': '今日班次考勤',
  'welcome.site': '物業',
  'welcome.siteShortName': '簡稱',
  'welcome.shift': '班次',
  'welcome.staff': '員工',
  'welcome.shiftStart': '班次開始',
  'welcome.attendance': '考勤',
  'welcome.checkedInAt': '已簽到 {time}',
  'welcome.noAttendanceLate': '未簽到（遲到）',
  'welcome.noAttendance': '未簽到',
  'welcome.latestUnclosedIncidents': '最新未結案事件',
  'welcome.totalUnclosed': '未結案總數：{count}',
  'welcome.low': '低：{count}',
  'welcome.medium': '中：{count}',
  'welcome.high': '高：{count}',
  'welcome.title': '標題',
  'welcome.severity': '嚴重程度',
  'welcome.state': '狀態',
  'welcome.createdAt': '建立時間',
  'welcome.loggedBy': '記錄人',
  'siteManagement.title': '物業管理',
  'siteManagement.content': '管理所有物業，包括創建、編輯和搜尋。',
  'siteManagement.addNewSite': '新增物業',
  'siteManagement.siteList': '物業列表',
  'siteManagement.name': '名稱',
  'siteManagement.shortName': '簡稱',
  'siteManagement.address': '地址',
  'siteManagement.region': '區域',
  'siteManagement.district': '地區',
  'siteManagement.status': '狀態',
  'siteManagement.active': '啟用',
  'siteManagement.inactive': '停用',
  'siteManagement.shifts': '班次',
  'siteManagement.action': '操作',
  'siteManagement.edit': '編輯',
  'siteManagement.viewDetails': '查看詳情',
  'siteManagement.addSite': '新增物業',
  'siteManagement.editSite': '編輯物業',
  'siteManagement.siteName': '物業名稱',
  'siteManagement.pleaseEnterSiteName': '請輸入物業名稱',
  'siteManagement.pleaseEnterShortName': '請輸入簡稱',
  'siteManagement.shortNameMax': '簡稱不能超過10個字元',
  'siteManagement.shortNameTooltip': '用於快速識別的簡稱，最多10個字元',
  'siteManagement.pleaseEnterAddress': '請輸入地址',
  'siteManagement.pleaseSelectRegion': '請選擇區域',
  'siteManagement.pleaseSelectDistrict': '請選擇地區',
  'siteManagement.searchName': '按名稱搜尋',
  'siteManagement.searchShortName': '按簡稱搜尋',
  'siteManagement.searchAddress': '按地址搜尋',
  'siteManagement.createSuccess': '物業建立成功',
  'siteManagement.updateSuccess': '物業更新成功',
  'siteManagement.operationFailed': '操作失敗',
  'siteManagement.showing': '顯示',
  'siteManagement.of': '共',
  'siteManagement.items': '條',
  'siteManagement.shiftCalendar': '班次日曆',
  'siteManagement.viewShiftCalendar': '查看班次日曆',
  'siteDetail.addNewShift': '新增班次',
  'siteDetail.addNewPhone': '新增電話',
  'siteDetail.addNewLog': '新增日誌',
  'siteDetail.addNewUnit': '新增單元',
  'siteDetail.addNewCheckpoint': '新增巡查點',
  'siteDetail.editCheckpointTitle': '編輯巡查點',
  'siteDetail.editUnitTitle': '編輯單元',
  'siteDetail.deleteConfirm': '確定要刪除此項嗎？',
  'siteDetail.saveSuccess': '儲存成功',
  'siteDetail.saveFailed': '儲存失敗',
  'siteDetail.deleteSuccess': '刪除成功',
  'siteDetail.deleteFailed': '刪除失敗',
  // removed duplicate keys at the end of file
  'siteDetail.pleaseEnter': '請輸入',
  'siteDetail.pleaseSelect': '請選擇',
  'staffLeave.title': '員工請假管理',
  'staffLeave.headerTitle': '請假記錄',
  'staffLeave.employeeId': '員工編號',
  'staffLeave.staffName': '員工姓名',
  'staffLeave.phone': '電話',
  'staffLeave.leaveType': '請假類型',
  'staffLeave.reason': '原因',
  'staffLeave.date': '日期',
  'staffLeave.status': '狀態',
  'staffLeave.approvedBy': '審批人',
  'staffLeave.approvedAt': '審批時間',
  'staffLeave.actions': '操作',
  'staffLeave.approveConfirm': '確認批准該請假嗎？',
  'staffLeave.rejectConfirm': '確認拒絕該請假嗎？',
  'staffLeave.approved': '已批准',
  'staffLeave.pending': '待審批',
  'staffLeave.rejected': '已拒絕',
  'staffLeave.approveSuccess': '請假已批准',
  'staffLeave.rejectSuccess': '請假已拒絕',
  'staffLeave.updateFailed': '更新請假失敗',
  'staffLeave.searchEmployeeId': '搜尋員工編號',
  'staffLeave.searchName': '搜尋姓名',
  'staffLeave.searchPhone': '搜尋電話',
  'leave.annual': '年假',
  'leave.sick': '病假',
  'leave.personal': '事假',
  'leave.other': '其他',
  'userManagement.title': '用戶管理',
  'userManagement.content': '管理用戶帳號及其狀態',
  'userManagement.userList': '用戶列表',
  'userManagement.createNewUser': '新增用戶',
  'userManagement.editUser': '編輯用戶',
  'userManagement.createUser': '新增用戶',
  'userManagement.resetPassword': '重設密碼',
  'userManagement.username': '用戶名',
  'userManagement.email': '電子郵件',
  'userManagement.role': '角色',
  'userManagement.status': '狀態',
  'userManagement.active': '啟用',
  'userManagement.inactive': '停用',
  'userManagement.createdAt': '建立時間',
  'userManagement.lastLogin': '最後登入',
  'userManagement.actions': '操作',
  'userManagement.newPassword': '新密碼',
  'userManagement.searchUsername': '搜尋用戶名',
  'userManagement.searchEmail': '搜尋電子郵件',
  'userManagement.pleaseInputUsername': '請輸入用戶名！',
  'userManagement.pleaseInputEmail': '請輸入電子郵件！',
  'userManagement.pleaseSelectRole': '請選擇角色！',
  'userManagement.pleaseInputNewPassword': '請輸入新密碼！',
  'userManagement.userUpdated': '用戶更新成功',
  'userManagement.userCreated': '用戶建立成功',
  'userManagement.saveUserFailed': '儲存用戶失敗',
  'userManagement.passwordResetSuccess': '密碼重設成功',
  'userManagement.passwordResetFailed': '密碼重設失敗',
  'userManagement.updateStatusFailed': '更新用戶狀態失敗',
  'userManagement.fetchRolesFailed': '取得角色失敗',
  'userManagement.accessDenied': '無權限存取',
  'userManagement.password': '密碼',
  'userManagement.pleaseInputPassword': '請輸入密碼！',
  'userManagement.oneTimePassword': '一次性密碼',
  'userManagement.faceRecognition': '人臉識別',
  'userManagement.fetchTokensFailed': '取得令牌失敗',
  'userManagement.tokenCreated': '令牌建立成功',
  'userManagement.createTokenFailed': '建立令牌失敗',
  'userManagement.copiedToClipboard': '已複製到剪貼簿',
  'userManagement.copyFailed': '複製失敗',
  'userManagement.tokenUpdated': '令牌更新成功',
  'userManagement.updateTokenFailed': '更新令牌失敗',
  'userManagement.tokenActivated': '令牌啟用成功',
  'userManagement.tokenDeactivated': '令牌停用成功',
  'userManagement.tokenStatusToggleFailed': '更新令牌狀態失敗',
  'userManagement.qrCodeGenerationFailed': 'QR碼生成失敗',
  'userManagement.oneTimePasswordTitle': '一次性密碼管理',
  'userManagement.tokenDescription': '令牌描述',
  'userManagement.tokenDescriptionPlaceholder': '輸入令牌描述（可選）',
  'userManagement.expiresInHours': '過期時間（小時）',
  'userManagement.createToken': '建立令牌',
  'userManagement.newTokenCreated': '新令牌已建立',
  'userManagement.copy': '複製',
  'userManagement.tokenWarning': '請務必保存此令牌，因為它只會顯示一次！',
  'userManagement.token': '令牌',
  'userManagement.description': '描述',
  'userManagement.noDescription': '無描述',
  'userManagement.used': '已使用',
  'userManagement.expired': '已過期',
  'userManagement.valid': '有效',
  'userManagement.expiresAt': '過期時間',
  'userManagement.usedAt': '使用時間',
  'userManagement.copyToken': '複製令牌',
  'userManagement.qrCode': 'QR碼',
  'userManagement.generateQRCode': '生成QR碼',
  'userManagement.qrCodeTitle': 'QR碼 - 一次性令牌',
  'userManagement.download': '下載',
  'userManagement.print': '列印',
  'userManagement.close': '關閉',
  'userManagement.authenticationURL': '認證URL',
  'userManagement.requestBody': '請求內容',
  'userManagement.tokenInfo': '令牌資訊',
  'userManagement.qrCodeInstructions': '掃描此QR碼以使用一次性令牌進行認證',
  'staffManagement.title': '員工管理',
  'staffManagement.staffList': '員工列表',
  'staffManagement.addStaff': '新增員工',
  'staffManagement.editStaff': '編輯員工',
  'staffManagement.employeeId': '員工編號',
  'staffManagement.name': '姓名',
  'staffManagement.lastName': '姓氏',
  'staffManagement.gender': '性別',
  'staffManagement.phone': '電話',
  'staffManagement.site': '物業',
  'staffManagement.status': '狀態',
  'staffManagement.action': '操作',
  'staffManagement.active': '在職',
  'staffManagement.inactive': '離職',
  'staffManagement.firstName': '名字',
  'staffManagement.titleLabel': '稱謂',
  'staffManagement.mr': '先生',
  'staffManagement.mrs': '夫人',
  'staffManagement.ms': '女士',
  'staffManagement.dr': '博士',
  'staffManagement.dateOfBirth': '出生日期',
  'staffManagement.address': '地址',
  'staffManagement.emergencyContact': '緊急聯絡人',
  'staffManagement.emergencyPhone': '緊急聯絡電話',
  'staffManagement.pleaseInputEmployeeId': '請輸入員工編號！',
  'staffManagement.pleaseInputFirstName': '請輸入名字！',
  'staffManagement.pleaseInputLastName': '請輸入姓氏！',
  'staffManagement.pleaseSelectGender': '請選擇性別！',
  'staffManagement.pleaseInputPhone': '請輸入電話！',
  'staffManagement.pleaseInputAddress': '請輸入地址！',
  'staffManagement.pleaseInputEmergencyContact': '請輸入緊急聯絡人！',
  'staffManagement.pleaseInputEmergencyPhone': '請輸入緊急聯絡電話！',
  'staffManagement.staffCreated': '員工建立成功',
  'staffManagement.staffUpdated': '員工更新成功',
  'staffManagement.operationFailed': '操作失敗',
  'staffManagement.accessDenied': '無權限存取',
  'staffManagement.searchEmployeeId': '搜尋員工編號',
  'staffManagement.searchFirstName': '搜尋名字',
  'staffManagement.searchLastName': '搜尋姓氏',
  'staffManagement.searchPhone': '搜尋電話',
  'staffManagement.filterBySite': '依物業篩選',
  'staffManagement.male': '男',
  'staffManagement.female': '女',
  'staffManagement.other': '其他',
  'dashboard.siteAttendanceSummary': '物業考勤摘要',
  'dashboard.date': '日期',
  'dashboard.selectDate': '選擇日期',
  'dashboard.attendance': '考勤',
  'dashboard.obRecords': 'OB',
  'dashboard.patrolRoutes': '巡邏',
  'dashboard.completed': '已完成',
  'dashboard.pending': '待處理',
  'dashboard.total': '總計',
  'dashboard.noSites': '未找到物業',
  'dashboard.loading': '正在載入考勤數據...',
  'dashboard.noSitesDesc': '請嘗試選擇其他日期或檢查物業配置',
  'dashboard.refresh': '刷新',
  'dashboard.unknownDistrict': '未知區域',
  'dashboard.unknownRegion': '未知地區',
  'dashboard.noData': '無數據',
  'dashboard.byDistrict': '按區域',
  'dashboard.byRegion': '按地區',
};
